import { render, staticRenderFns } from "./RestaurantOrderListItem.vue?vue&type=template&id=5b6db1ae&"
import script from "./RestaurantOrderListItem.vue?vue&type=script&lang=js&"
export * from "./RestaurantOrderListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports